import { NAMESPACE } from "./_Namespace";

class StringHelper
{
    // #region Global Variables

    public static readonly empty = "";

    // #endregion

    // #region Public Methods

    public static padLeft(s: string, length: number, char: string)
    {
        let
            output = s;

        if (length > 0 && char.length > 0)
        {
            while (output.length < length)
                output = char + output;
        }

        return output;
    }

    // #endregion
}

export class DateHelper
{
    public static classNamespace = NAMESPACE + "DateHelper";
    public static className = "DateHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Global Variables

    public static dayArray = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    public static monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // #endregion

    // #region Public Methods

    public static addDays(date: Date, days: number): Date
    {
        const
            newDate = new Date(date.valueOf());

        newDate.setDate(newDate.getDate() + days);

        return newDate;
    }
    public static addHours(date: Date, hours: number): Date
    {
        const
            hoursInMilliseconds = hours * 60 * 60 * 1000,
            newDate = new Date(date.valueOf());

        newDate.setTime(newDate.getTime() + hoursInMilliseconds);

        return newDate;
    }
    public static addMinutes(date: Date, minutes: number): Date
    {
        const
            minutesInMilliseconds = minutes * 60 * 1000,
            newDate = new Date(date.valueOf());

        newDate.setTime(newDate.getTime() + minutesInMilliseconds);

        return newDate;
    }
    public static addMonths(date: Date, months: number): Date
    {
        const
            newDate = new Date(date.valueOf());

        newDate.setMonth(newDate.getMonth() + months);

        return newDate;
    }
    public static addSeconds(date: Date, seconds: number): Date
    {
        const
            secondsInMilliseconds = seconds * 1000,
            newDate = new Date(date.valueOf());

        newDate.setTime(newDate.getTime() + secondsInMilliseconds);

        return newDate;
    }
    public static addYears(date: Date, years: number): Date
    {
        const
            newDate = new Date(date.valueOf());

        newDate.setFullYear(newDate.getFullYear() + years);

        return newDate;
    }
    public static convertToUtc(date: Date)
    {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }
    public static createAsUTC(date: Date)
    {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    }
    public static fromString(dateString: string, format: string): Date
    {
        let
            result = this.tryFromString(dateString, format);

        if (!result.success && format.indexOf("f") > -1)
            result = this.tryFromString(dateString, format.replace(/[.f]/gi, StringHelper.empty));

        if (result.success)
            return result.date;

        throw new Error(result.error);
    }
    public static toString(date: Date, format: string): string
    {
        if (isNaN(date.getFullYear()))
            return "Invalid Date";

        const
            dateObject = format && format.endsWith("Z") ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : date,
            year = String(dateObject.getFullYear()),
            yearShort = year.substring(2),
            month = dateObject.getMonth() + 1,
            monthString = String(month),
            day = dateObject.getDay(),
            dateString = String(dateObject.getDate()),
            hours = dateObject.getHours(),
            hoursString = String(hours),
            hours12 = hours > 12 ? hours % 12 : hours,
            hours12String = String(hours12),
            ampm = hours < 12 ? "AM" : "PM",
            minutes = String(dateObject.getMinutes()),
            seconds = String(dateObject.getSeconds()),
            milliseconds = dateObject.getMilliseconds(),
            timezoneOffset = -dateObject.getTimezoneOffset(),
            timezone = {
                direction: timezoneOffset >= 0 ? "+" : "-",
                hours: timezoneOffset / 60,
                minutes: timezoneOffset % 60
            };

        let
            returnString = "";

        if (typeof format === "undefined")
            format = "dd/MM/yyyy HH:mm:ss";

        returnString = String(format);

        returnString = returnString.replace(/fffffff/g, "$01");
        returnString = returnString.replace(/ffffff/g, "$01");
        returnString = returnString.replace(/fffff/g, "$01");
        returnString = returnString.replace(/ffff/g, "$01");
        returnString = returnString.replace(/fff/g, "$01");
        returnString = returnString.replace(/ff/g, "$02");
        returnString = returnString.replace(/f/g, "$03");
        returnString = returnString.replace(/ss/g, "$04");
        returnString = returnString.replace(/s/g, "$05");
        returnString = returnString.replace(/mm/g, "$06");
        returnString = returnString.replace(/m/g, "$07");
        returnString = returnString.replace(/hh/g, "$08");
        returnString = returnString.replace(/h/g, "$09");
        returnString = returnString.replace(/HH/g, "$10");
        returnString = returnString.replace(/H/g, "$11");
        returnString = returnString.replace(/dddd/g, "$12");
        returnString = returnString.replace(/ddd/g, "$13");
        returnString = returnString.replace(/dd/g, "$14");
        returnString = returnString.replace(/d/g, "$15");
        returnString = returnString.replace(/MMMM/g, "$16");
        returnString = returnString.replace(/MMM/g, "$17");
        returnString = returnString.replace(/MM/g, "$18");
        returnString = returnString.replace(/M/g, "$19");
        returnString = returnString.replace(/yyyy/g, "$20");
        returnString = returnString.replace(/yyy/g, "$21");
        returnString = returnString.replace(/yy/g, "$22");
        returnString = returnString.replace(/y/g, "$23");
        returnString = returnString.replace(/tt/g, "$24");
        returnString = returnString.replace(/Z/g, "$25");

        returnString = returnString.replace(/\$01/g, Math.floor(milliseconds).toFixed());
        returnString = returnString.replace(/\$02/g, Math.floor(milliseconds / 10).toFixed());
        returnString = returnString.replace(/\$03/g, Math.floor(milliseconds / 100).toFixed());

        returnString = returnString.replace(/\$04/g, StringHelper.padLeft(seconds, 2, "0"));
        returnString = returnString.replace(/\$05/g, seconds);

        returnString = returnString.replace(/\$06/g, StringHelper.padLeft(minutes, 2, "0"));
        returnString = returnString.replace(/\$07/g, minutes);

        returnString = returnString.replace(/\$08/g, StringHelper.padLeft(hours12String, 2, "0"));
        returnString = returnString.replace(/\$09/g, hours12String);

        returnString = returnString.replace(/\$10/g, StringHelper.padLeft(hoursString, 2, "0"));
        returnString = returnString.replace(/\$11/g, hoursString);

        returnString = returnString.replace(/\$12/g, DateHelper.dayArray[day]);
        returnString = returnString.replace(/\$13/g, DateHelper.dayArray[day].substring(0, 3));
        returnString = returnString.replace(/\$14/g, StringHelper.padLeft(dateString, 2, "0"));
        returnString = returnString.replace(/\$15/g, dateString);

        returnString = returnString.replace(/\$16/g, DateHelper.monthArray[month - 1]);
        returnString = returnString.replace(/\$17/g, DateHelper.monthArray[month - 1].substring(0, 3));
        returnString = returnString.replace(/\$18/g, StringHelper.padLeft(monthString, 2, "0"));
        returnString = returnString.replace(/\$19/g, monthString);

        returnString = returnString.replace(/\$20/g, StringHelper.padLeft(year, 4, "0"));
        returnString = returnString.replace(/\$21/g, year);
        returnString = returnString.replace(/\$22/g, yearShort);
        returnString = returnString.replace(/\$23/g, StringHelper.padLeft(yearShort, 2, "0"));

        returnString = returnString.replace(/\$24/g, ampm);
        returnString = returnString.replace(/\$25/g, format && format.endsWith("Z") ? "Z" : timezone.direction + StringHelper.padLeft(timezone.hours.toString(), 2, "0") + ":" + StringHelper.padLeft(timezone.minutes.toString(), 2, "0"));

        return returnString;
    }
    public static tryFromString(dateString: string, format: string): { success: true, date: Date } | { success: false, error: string }
    {
        const
            ERROR_DATE_STRING_FORMAT = "Date string does not match supplied format.",
            ERROR_INVALID_DATE_FORMAT = "Invalid date format.";

        function getNumber(minLength: number, maxLength: number, min: number, max?: number)
        {
            const
                matches = /^[0-9]+/g.exec(dateString);

            if (!matches || matches.length === 0)
                throw ERROR_DATE_STRING_FORMAT;

            const
                numbers = matches[0];

            if (minLength !== undefined && numbers.length < minLength || maxLength !== undefined && numbers.length > maxLength)
                throw ERROR_DATE_STRING_FORMAT;

            dateString = dateString.substring(numbers.length);

            const
                number = parseInt(numbers);

            if (min !== undefined && number < min || max !== undefined && number > max)
                throw ERROR_DATE_STRING_FORMAT;

            return number;
        }

        function getTimezone()
        {
            const
                matches = /^(\+|-)([0-9][0-9]):([0-9][0-9])/g.exec(dateString);

            if (!matches || matches.length === 0)
                throw ERROR_DATE_STRING_FORMAT;

            dateString = dateString.substring(6);

            return {
                positive: matches[1] === "+",
                hours: parseInt(matches[2]),
                minutes: parseInt(matches[3])
            };
        }

        function getAmPm()
        {
            const
                ampm = dateString.substring(0, 2).toUpperCase();

            switch (ampm)
            {
                case "AM":
                case "PM":
                    dateString = dateString.substring(2);
                    return ampm;
            }

            throw ERROR_INVALID_DATE_FORMAT;
        }

        function getMonth(abbreviated: boolean)
        {
            for (let j = 0; j < DateHelper.monthArray.length; j++)
            {
                if (abbreviated)
                {
                    if (DateHelper.monthArray[j].substring(0, 3).toLowerCase() === dateString.substring(0, 3).toLowerCase())
                    {
                        dateString = dateString.substring(3);
                        return j;
                    }
                }
                else
                {
                    if (DateHelper.monthArray[j].toLowerCase() === dateString.substring(0, DateHelper.monthArray[j].length).toLowerCase())
                    {
                        dateString = dateString.substring(DateHelper.monthArray[j].length);
                        return j;
                    }
                }
            }

            throw ERROR_INVALID_DATE_FORMAT;
        }

        try
        {
            let
                year,
                month,
                day,
                hours,
                hours12,
                minutes,
                seconds,
                milliseconds,
                ampm,
                date,
                isUtc = false;

            for (let i = 0; i < format.length; i++)
            {
                let
                    datePart = format[i];

                while (format.length > i && format[i + 1] === datePart[0])
                {
                    i++;
                    datePart += format[i];
                }

                if (datePart[0] === "Z")
                {
                    if (dateString[0] === "Z")
                    {
                        dateString = dateString.substring(1);
                        isUtc = true;
                    }
                }
                else if (datePart[0] === "t")
                    ampm = getAmPm();
                else if (datePart[0] === "f")
                {
                    milliseconds = getNumber(1, datePart.length, 0, undefined);

                    while (milliseconds.toString().length > 3)
                        milliseconds = Math.round(milliseconds / 10);
                }
                else if (datePart[0] === "s")
                    seconds = getNumber(1, 2, 0, 59);
                else if (datePart[0] === "m")
                    minutes = getNumber(1, 2, 0, 59);
                else if (datePart[0] === "h")
                    hours12 = getNumber(1, 2, 0, 11);
                else if (datePart[0] === "H")
                    hours = getNumber(1, 2, 0, 23);
                else if (datePart[0] === "d")
                    day = getNumber(1, 2, 1, 31);
                else if (datePart[0] === "M")
                {
                    switch (datePart.length)
                    {
                        case 1:
                        case 2:
                            month = getNumber(1, 2, 1, 12) - 1;
                            break;
                        case 3:
                            month = getMonth(true);
                            break;
                        case 4:
                            month = getMonth(false);
                            break;
                    }
                }
                else if (datePart[0] === "y")
                {
                    switch (datePart.length)
                    {
                        case 1:
                            year = getNumber(2, 4, 0);
                            break;
                        case 2:
                        case 3:
                        case 4:
                            year = getNumber(datePart.length, datePart.length, 0);
                            break;
                        default:
                            throw ERROR_INVALID_DATE_FORMAT;
                    }

                    if (year.toString().length === 2)
                    {
                        const
                            currentDate = new Date(),
                            currentCentury = Math.round(currentDate.getFullYear() / 100);

                        year += currentCentury * 100;
                        if (year > currentDate.getFullYear() + 20)
                            year -= 100;
                    }
                }
                else
                {
                    while (dateString.length && datePart.length && dateString[0] === datePart[0])
                    {
                        dateString = dateString.substring(1);
                        datePart = datePart.substring(1);
                    }

                    if (datePart === ".")
                    {
                        datePart = StringHelper.empty;

                        while (format.length > i && (format[i + 1] === "." || format[i + 1] === "f"))
                            i++;
                    }

                    if (datePart.length)
                        throw ERROR_DATE_STRING_FORMAT;
                }
            }

            if (hours === undefined)
            {
                if (hours12 !== undefined)
                    hours = hours12 + (ampm === "PM" ? 12 : 0);
            }

            if (year === undefined)
                year = 0;

            if (month === undefined)
                month = 0;

            if (day === undefined)
                day = 1;

            if (hours === undefined)
                hours = 0;

            if (minutes === undefined)
                minutes = 0;

            if (seconds === undefined)
                seconds = 0;

            if (milliseconds === undefined)
                milliseconds = 0;

            date = isUtc ? new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds)) : new Date(year, month, day, hours, minutes, seconds, milliseconds);

            return {
                success: true,
                date: date
            };
        }
        catch (e)
        {
            return { success: false, error: typeof e === "string" ? e : "Error converting string to Date" };
        }
    }

    // #endregion
}